import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import IconDay from 'assets/dashboard/day.svg?react';

import Messages from 'i18n/messages/dashboard';

import { RibbonButton } from 'common/components';
import * as dashboardSelectors from 'pages/dashboard/controllers/selectors';
import * as dashboardActions from 'pages/dashboard/controllers/actions';

const ScheduleView = () => {
  const dispatch = useDispatch();
  const calendarView = useSelector(dashboardSelectors.makeSelectCalendarView());
  return (
    <RibbonButton
      icon={<IconDay />}
      label={Messages.scheduleView}
      onClick={() => dispatch(dashboardActions.calendarScheduleView('agenda'))}
      toggle={calendarView === 'agenda'}
    />
  );
};

export default ScheduleView;
